/**
 * @param {object} params
 * @param {import("../../../types/Campaign").Campaign} [params.campaign]
 * @param {import("../../../types/Campaign").CampaignAttributeName} params.name
 */
export function getCampaignAttribute({ campaign, name }) {
  return campaign?.attributes?.find((attr) => attr.name === name)?.value;
}
